module.exports = __webpack_public_path__ + "img/58.8.5d418b4a.png";